import { SxProps, Theme } from '@mui/material'

export let modalPaperProps = {
  sx: { bgcolor: 'background.default' },
} as const

export let modalInputSx: SxProps<Theme> = {
  bgcolor: 'background.paperDark',
}
